// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2pwi8","signatureBlock":"Footer_signatureBlock__1OvPw","signature":"Footer_signature__3QUlM"};